// extracted by mini-css-extract-plugin
export default {"mySubjectsTitleSpecial":"ArchiveClasses_mySubjectsTitleSpecial__PxB1S","udcClassessContainer":"ArchiveClasses_udcClassessContainer__gL4nz"};